import React, { useEffect } from "react";
import { TOptionValue } from "../../optionsUtils";

import "./Checkbox.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/pro-solid-svg-icons";

interface IProps {
    value: TOptionValue;
    onClick?: (e) => void;
    disabled?: boolean;
}

export default function Checkbox(props: IProps) {
    const [value, setValue] = React.useState<TOptionValue | string>(props.value || "unselected");

    const onClick = (e) => {

        if (props.disabled) {
            return;
        }

        if (props.onClick) {
            props.onClick(e);

            return;
        }

        if (value === "inherited") {
            setValue("selected");
            return;
        }

        if (value === "selected") {
            setValue("unselected");
        } else if (value === "unselected") {
            setValue("selected");
        } else {
            setValue("indeterminate");
        }
    };

    useEffect(() => {
        if (props.value) {
            setValue(props.value);
        }
    }, [props.value]);

    return (
        <button
            disabled={props.disabled}
            type="button"
            onClick={onClick}
            className={`userful-checkbox ${
                value === "selected"
                    ? "userful-checkbox-selected"
                    : value === "indeterminate"
                      ? "userful-checkbox-indeterminate"
                      : value === "inherited"
                        ? "userful-checkbox-inherited"
                        : ""
            }`}
        >
            {value === "selected" && (
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="8" viewBox="0 0 11 8" fill="none">
                    <path
                        d="M1 4.32857L3.67148 7L9.64291 1"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            )}
            {value === "indeterminate" && (
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="2" viewBox="0 0 10 2" fill="none">
                    <path d="M1 1H9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            )}
            {value === "inherited" && <FontAwesomeIcon icon={faUser} />}
        </button>
    );
}
